import script from "./B2BReceiptHeroTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./B2BReceiptHeroTile.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__